/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */



angular.module('FlexyBeautyApp.services').
    factory('DayPr_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/DayPrs/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' },
            saveWithoutActivities:  { method: 'POST' , url:baseUrl+'rest/DayPrs/withoutActivities'}
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('DayPr',["DayPr_Resource","Activity","DayPrData","Period", "BookingService",
    function (DayPr_Resource,Activity,DayPrData,Period,BookingService)
    {
        //WorkingPeriodDay inherit of $resource

        var  DayPr = function (resource,day,isPreviousVersion, isApplicationLoading)
        {
            this.id = null;
            this.prUnitId = null;
            this.physicalResourceId = null;
            this.day = null;
            this.hasSpecificWpPeriods = false;
            this.hasSpecificOnLineBooking = false;
            this.onLineBooking = true;
            this.activities = [];
            this.periods = [];//Periods of work for a day;
            this.availablePeriods = [];
            this.comment = null;
            this.version = null;
            if (day!==undefined && day!=null)
            {
                this.day=day;
            }

            if (resource!==undefined && resource!=null)
            {
                this.loadObject(resource, isApplicationLoading);
            }
            if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
                DayPrData.add(this);
        }
        DayPr.prototype.loadObject = function(object, isApplicationLoading)
        {
            this.loadObjectProperties(object);
            this.loadObjectActivities(object, isApplicationLoading);
        };
        DayPr.prototype.loadObjectProperties = function(object)
        {
            if (!this.id)
                this.id = object.id;
            this.prUnitId = object.prUnitId;
            this.physicalResourceId = object.physicalResourceId;
            this.hasSpecificWpPeriods = object.hasSpecificWpPeriods;
            this.hasSpecificOnLineBooking = object.hasSpecificOnLineBooking;
            this.onLineBooking = object.onLineBooking;
            this.comment = object.comment;
            if (object.periods)
            {
                this.periods=[];
                for (var j =0;j< object.periods.length;j++)
                    this.addPeriodOnPr(object.periods[j]);
            }
            if (object.availablePeriods)
            {
                this.availablePeriods = [];
                for (var j =0;j< object.availablePeriods.length;j++)
                    this.addAvailablePeriod(object.availablePeriods[j]);
            }
            if (object.version)
                this.version = object.version;
        }

        DayPr.prototype.loadObjectActivities = function(object, isApplicationLoading) {
            if (object.activities) {
                let activitiesId = [] ;
                this.activities.forEach(activity => {
                    if(!activity.booking) {
                        activitiesId.push(activity.id);
                    }
                });
                for (let i = 0; i < object.activities.length; i++) {
                    //Could be an simple activity or a bookingService
                    if (object.activities[i].objectType == "Activity" ) {
                        if(activitiesId.indexOf(object.activities[i].id) === -1) {
                            let activity = new Activity(object.activities[i], null, isApplicationLoading);
                            activity.dayPr = this;
                            this.activities.push(activity);
                        }
                    } else {
                        //Get BookingService Object from Booking instead
                        let bs = this.day.getBookingServiceById(object.activities[i].id);
                        if (bs) {
                            if (bs._dayPrId == this.id) {
                                bs.dayPr = this;
                            } else {
                                bs.addSecondaryDayPr(this);
                            }
                            this.activities.push(bs);
                        }
                    }
                }
            }
        };

        DayPr.prototype.addPeriodOnPr = function(period)
        {
            if (period)
                this.periods.push(new Period(period));
        }
        DayPr.prototype.addAvailablePeriod = function(period)
        {
            if (period)
                this.availablePeriods.push(new Period(period));
        }
        DayPr.prototype.getObjectResource = function()
        {
            var res = this.getObjectResourceWithoutActivities();
            //Add activities
            res.activities=[];
            if (this.activities)
                for (var i =0;i< this.activities.length;i++)
                    res.activities.push(this.activities[i].getObjectResource());
            return  res;
        }
        DayPr.prototype.getObjectResourceWithoutActivities = function()
        {
            //Get only Period data
            var res = new DayPr_Resource();
            res.id = this.id;
            res.prUnitId = this.prUnitId;
            res.physicalResourceId = this.physicalResourceId;
            res.hasSpecificWpPeriods = this.hasSpecificWpPeriods;
            res.hasSpecificOnLineBooking = this.hasSpecificOnLineBooking;
            res.onLineBooking = this.onLineBooking;
            res.comment = this.comment;
            if (this.day)
                res.dayId = this.day.id;
            //NoActivity
            res.periods=[];
            if (this.periods)
                for (var i =0;i< this.periods.length;i++)
                    res.periods.push(
                        {
                            start :
                            {
                                hour:this.periods[i].start.hour,
                                minute:this.periods[i].start.minute
                            },
                            end :
                            {
                                hour:this.periods[i].end.hour,
                                minute:this.periods[i].end.minute
                            }
                        }
                    );

            return  res;
        }
        DayPr.prototype.getObjectResourceCreatedByActivity = function()
        {
            //when created by activity : hasSpecificWpPeriods = false and periods is empty
            var res = new DayPr_Resource();
            res.id = this.id;
            res.prUnitId = this.prUnitId;
            res.physicalResourceId = this.physicalResourceId;
            if (this.day)
                res.dayId = this.day.id;
            return res;
        }
        DayPr.prototype.setId = function(id)
        {
            this.id = id;
        }
        DayPr.prototype.getId = function()
        {
            return this.id;
        }
        DayPr.prototype.addActivity = function(activity,isPrimary)
        {
            if (activity)
            {
                var index = this.activities.indexOf(activity);
                if (index==-1)
                    this.activities.push(activity);
                if (isPrimary===undefined || isPrimary)
                    activity.dayPr = this;
                else
                    activity.addSecondaryDayPr(this);
            }
        }
        DayPr.prototype.removeActivity = function(activity)
        {
            if (activity)
            {
                var index = this.activities.indexOf(activity);
                if (index!=-1)
                    this.activities.splice(index,1);
            }
        }
        DayPr.prototype.isOpenWorkingPeriodForPr= function(period)
        {
            var isOpen = false;
            for (var i =0;i< this.periods.length&&!isOpen;i++)
                isOpen =  ((period.start.hour *60 + period.start.minute)<
                (this.periods[i].end.hour *60 + this.periods[i].end.minute)) &&
                ((period.end.hour *60 + period.end.minute)>
                    (this.periods[i].start.hour *60 + this.periods[i].start.minute));
            return isOpen;
        }
        DayPr.prototype.getActivityById = function(id)
        {
            for (var i =0;i< this.activities.length;i++)
                if (this.activities[i].id==id)
                    return this.activities[i];
            return null;
        };
        DayPr.prototype.calculateMaxPeriod = function(period)
        {
            for (var k = 0; k < this.periods.length; k++) {
                if (this.periods[k] && this.periods[k].duration!=0)
                {
                    if ((this.periods[k].start.getTime())<(period.start.getTime()))
                    {
                        period.setStartHour(this.periods[k].start.hour);
                        period.setStartMinute(this.periods[k].start.minute);
                        console.log("Found max period on " + this.day.id + " prid:"+this.physicalResourceId)

                    }
                    if ((this.periods[k].end.getTime())>(period.end.getTime()))
                    {
                        period.setEndHour(this.periods[k].end.hour);
                        period.setEndMinute(this.periods[k].end.minute);
                        console.log("Found max period on " + this.day.id + " prid:"+this.physicalResourceId)
                    }
                }
            }
        };
        DayPr.prototype.hasBookingActivities = function()
        {
            for (var i =0;i< this.activities.length;i++)
                if (this.activities[i].objectType!="Activity")
                    return true;
            return false;
        };
        DayPr.prototype.getPrWorkingTime = function()
        {
            var prWorkingTime = 0;
            for (var i =0;i< this.periods.length;i++)
                prWorkingTime += this.periods[i].duration;
            return prWorkingTime;
        }
        DayPr.prototype.getPrBookingTime = function()
        {
            var prBookingTime = 0;
            for (var i =0;i< this.activities.length;i++)
                if (this.activities[i] instanceof BookingService &&
                    this.activities[i].period &&
                    ((this.activities[i].booking && this.activities[i].booking.status!='notCame') || (this.activities[i].pkg && this.activities[i].pkg.booking && this.activities[i].pkg.booking.status!='notCame')))
                    prBookingTime += this.activities[i].period.duration;
            return prBookingTime;
        }
//        DayPr.prototype.isAvailableForPeriod= function(period)
//        {
//            var isAvailable = false;
//            var i= 0;
//            if (period)
//                for (var u =0;u< this.dayPrUnits.length;u++)
//                    for (i= 0; i<this.dayPrUnits[u].availablePeriods.length && !isAvailable && this.dayPrUnits[u].availablePeriods[i].start.getTime()<=period.start.getTime();i++)
//                        isAvailable = this.dayPrUnits[u].availablePeriods[i].contains(period);
//
//            return isAvailable;
//        }
        return DayPr;
    }
    ]);

angular.module('FlexyBeautyApp.services').factory('DayPrSrv',[
        "$log", "DayPr_Resource", "DayPrData", "DayPr", "DayData", "ServerSrv", "UserActionData", 
    function ($log, DayPr_Resource, DayPrData, DayPr, DayData, ServerSrv, UserActionData) {
        var  DayPrSrv = {};

        DayPrSrv.save =  function(dayPr,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(DayPrSrv.saveSync, dayPr, successFunction, errorFunction);
        };
        DayPrSrv.saveSync = function(dayPr,successFunction,errorFunction)
        {
            //$timeout (function () {

            var DayPrRes = dayPr.getObjectResource();
            DayPrRes.$save({}, //no params
                function (dayPrRes) {
                    try {
                        dayPr.setId(dayPrRes.id);
                        if (!dayPr.version || (dayPrRes.version && dayPrRes.version > dayPr.version))
                            dayPr.version = dayPrRes.version;
                        if (dayPrRes.activitiesId && dayPrRes.activitiesId.length == dayPr.activities.length)
                        //Assume that returned list has the same order
                            for (var i = 0; i < dayPrRes.activitiesId.length; i++)
                                dayPr.activities[i].setId(dayPrRes.activitiesId[i]);

                        //Add user action
                        UserActionData.add(dayPrRes.userAction);

                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(dayPrRes);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        DayPrSrv.saveWithoutActivities =  function(dayPr,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(DayPrSrv.saveSyncWithoutActivities, dayPr, successFunction, errorFunction);
        };
        DayPrSrv.saveSyncWithoutActivities =  function(dayPr,successFunction,errorFunction)
        {
            //$timeout (function () {

            var DayPrRes = dayPr.getObjectResourceWithoutActivities();
            DayPrRes.$saveWithoutActivities({}, //no params
                function (dayPrRes) {
                    try {
                        dayPr.setId(dayPrRes.id);
                        if (!dayPr.version || (dayPrRes.version && dayPrRes.version > dayPr.version))
                            dayPr.version = dayPrRes.version;
                        if (dayPrRes.activitiesId && dayPrRes.activitiesId.length==dayPr.activities.length)
                        //Assume that returned list has the same order
                            for (var i=0;i< dayPrRes.activitiesId.length;i++)
                                dayPr.activities[i].setId(dayPrRes.activitiesId[i]);

                        //Add user action
                        UserActionData.add(dayPrRes.userAction);

                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(dayPrRes);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        DayPrSrv.remove =  function(dayPr,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(DayPrSrv.removeSync, dayPr, successFunction, errorFunction);
        };
        DayPrSrv.removeSync =  function(dayPr,successFunction,errorFunction)
        {
            //$timeout (function () {

            var DayPrRes = new DayPr_Resource();
            DayPrRes.$remove({id:dayPr.id}, //no params
                function (dayPrRes) {
                    if (!dayPr.version || (dayPrRes.version && dayPrRes.version > dayPr.version))
                        dayPr.version = dayPrRes.version;
                    try{
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(dayPrRes);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };

        DayPrSrv.updateLocally = function(id, resource) {
            let dayPr = DayPrData.getById(id);
            if (dayPr) {
                if (dayPr.version && resource.version && resource.version < dayPr.version) {
                    return null;
                }
                dayPr.loadObjectProperties(resource);
            } else {
                console.log("DayPr.updateLocally - Model not found given ID - DayPr ID: " + id);
            }
            return dayPr;
        };

        DayPrSrv.removeLocally = function(id, resource) {
            let dayPr = DayPrData.getById(id);
            if (dayPr) {
                if (dayPr.version && resource.version && resource.version < dayPr.version) {
                    return null;
                }

                if (dayPr.day) {
                    dayPr.day.removeDayPr(dayPr)
                } else {
                    console.log("DayPr.removeLocally - dayPr.day is null - DayPr ID: " + id);
                }
            } else {
                console.log("DayPr.removeLocally - Model not found given ID - DayPr ID: " + id);
            }
            return dayPr;
        };

        DayPrSrv.addLocally = function(id, resource) {
            let dayPr = DayPrData.getById(id);
            if (dayPr && dayPr.version && resource.version && resource.version < dayPr.version) {
                return null;
            }

            if (dayPr != null) {
                console.log("DayPr.addLocally - Model already exists - DayPr ID: " + id);
                dayPr.loadObjectProperties(resource);
            } else {
                let day = DayData.getById(resource.dayId);
                if (day) {
                    dayPr = new DayPr(resource,day);
                    dayPr.id = id;
                    day.addDayPr(dayPr);
                } else {
                    console.log("DayPr.addLocally - Day not found given ID - Day ID: " + resource.dayId);
                }
            }
            return dayPr;
        };

        DayPrSrv.getPreviousVersionInstance =  function(resource)
        {
            var day = null;
            if (resource.dayId)
                 day = DayData.getById(resource.dayId);
            var dayPr =  new DayPr(resource,day,true);
            return dayPr;

        };

        return DayPrSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('DayPrData',[ function ()
    {
        var  dayPrData = {
            indexDayPrs : []
        };
        dayPrData.getById =  function(dayPrId)
        {
            for (var i=0;i<this.indexDayPrs.length;i++)
                if (this.indexDayPrs[i].id==dayPrId)
                    return this.indexDayPrs[i];
            return null;
        }
        dayPrData.getIndexOf =  function(dayPr)
        {
            if (dayPr)
                return this.indexDayPrs.indexOf(dayPr);
            return -1;
        }
        dayPrData.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexDayPrs.length)
                return this.indexDayPrs[index];
            return null;
        }
        dayPrData.add =  function(dayPr)
        {
            this.indexDayPrs.push(dayPr);
            return this.indexDayPrs.length-1;
        }
        dayPrData.clear =  function()
        {
            this.indexDayPrs = [];
        }
        return   dayPrData;
    }
    ]);




// WEBPACK FOOTER //
// ./js/services/models/DayPr.js